"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Waar kan ik parkeren in de buurt van de barbershop?",
  answer: "U kunt gratis parkeren in de buurt van onze winkel aan het Zandpad 2 in Middelharnis. Er zijn meestal voldoende parkeerplaatsen beschikbaar op korte loopafstand van de barbershop."
}, {
  question: "Hoe maak ik een afspraak?",
  answer: "We gebruiken Salonkee voor al onze boekingen om een soepel en snel proces te garanderen. U kunt eenvoudig online uw afspraak inplannen door op een van de 'Maak een afspraak' knoppen op onze website te klikken."
}, {
  question: "Accepteren jullie ook klanten zonder afspraak?",
  answer: "Hoewel we ten zeerste aanraden om vooraf te boeken via Salonkee om uw plek te garanderen en wachttijden te voorkomen, accepteren we klanten zonder afspraak als we direct beschikbaarheid hebben."
}, {
  question: "Welke betaalmethoden accepteren jullie?",
  answer: "Voor uw gemak accepteren we zowel PIN (betaalpassen) als contante betalingen in de barbershop."
}, {
  question: "Bieden jullie ook knipbeurten voor kinderen aan?",
  answer: "Ja, we bieden gespecialiseerde knipbeurten voor jongens aan. Onze ervaren kappers zorgen voor een comfortabele, snelle en nauwkeurige service voor onze jongere klanten."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="veelgestelde-vragen" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white font-sans tracking-tight">
            Veelgestelde vragen
          </h2>
          {}
          <div className="h-1 w-20 bg-primary mx-auto mt-6 rounded-full opacity-80"></div>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/20 py-2">
              {}
              <AccordionTrigger className="text-white font-bold font-sans text-left text-base md:text-lg hover:no-underline hover:text-primary transition-colors duration-300">
                {faq.question}
              </AccordionTrigger>
              {}
              <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed pt-2 pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}